/**
 * Centralized logging utility with configurable log levels
 * 
 * Usage:
 * - Set REACT_APP_LOG_LEVEL in .env file or environment
 * - Levels: ERROR (1), WARN (2), INFO (3), DEBUG (4)
 * - Default: INFO for production, DEBUG for development
 * 
 * Examples:
 *   logger.error('Critical error:', error);
 *   logger.warn('Warning message');
 *   logger.info('Info message');
 *   logger.debug('Debug details:', data);
 */

const LOG_LEVELS = {
    ERROR: 1,
    WARN: 2,
    INFO: 3,
    DEBUG: 4
};

// Get log level from environment or default
const getLogLevel = () => {
    const envLevel = process.env.REACT_APP_LOG_LEVEL?.toUpperCase();
    if (envLevel && LOG_LEVELS[envLevel]) {
        return LOG_LEVELS[envLevel];
    }
    // Default: WARN (errors and warnings only)
    return LOG_LEVELS.WARN;
};

const currentLogLevel = getLogLevel();

const logger = {
    error: (...args) => {
        if (currentLogLevel >= LOG_LEVELS.ERROR) {
            console.error(...args);
        }
    },
    
    warn: (...args) => {
        if (currentLogLevel >= LOG_LEVELS.WARN) {
            console.warn(...args);
        }
    },
    
    info: (...args) => {
        if (currentLogLevel >= LOG_LEVELS.INFO) {
            console.log(...args);
        }
    },
    
    debug: (...args) => {
        if (currentLogLevel >= LOG_LEVELS.DEBUG) {
            console.log(...args);
        }
    },
    
    // Special: Always log regardless of level (use sparingly)
    always: (...args) => {
        console.log(...args);
    }
};

export default logger;
